import api from '@app/api'
import {
	AppliersFilters,
	AssignPatientDataRequest,
	PatientData,
	PatientDataTableModel,
	PatientFilter,
	SEARCH_PATIENTS_ACTION_TYPES,
	SearchPatientsReset,
	UnassignPatientDataRequest,
} from '@app/types/patients'
import { AppThunkAction } from '@app/store'
import { executeResponseError } from '@app/helpers'

import { setSelectedCoach } from '../coaches/actions'

export const removePatient = (
	id: string | null
): AppThunkAction<Promise<Array<PatientData>>> => {
	return async () => {
		if (!id) return

		try {
			const res = await api.patient.removePatient(id, {
				ordersToCancel: [],
			})
			return res.data.result
		} catch (e: any) {
			const error = executeResponseError(e, `Patient didn't remove`)
			throw new Error(error || '')
		}
	}
}

export const setSelectedAssignPatients = (
	patients: string[]
): AppThunkAction => {
	return dispatch => {
		dispatch({
			type: SEARCH_PATIENTS_ACTION_TYPES.SELECTED_ASSIGN_PATIENTS,
			payload: patients,
		})
	}
}

export const setAllPatients = (
	data: PatientData[],
	count: any
): AppThunkAction => {
	return dispatch => {
		dispatch({
			type: SEARCH_PATIENTS_ACTION_TYPES.GET_ALL_PATIENTS,
			payload: data,
			filteredPatientsCount: count,
		})
	}
}

export const getPatientsList = (data: any): AppThunkAction<Promise<any>> => {
	return async (dispatch, getState) => {
		try {
			const res = await api.patient.getPatientsList(data)
			const newRes = res.data.result.data.map((item: any): any => {
				item.id = item._id
				return item
			})
			dispatch(setSelectedAssignPatients([]))
			dispatch(setAllPatients(newRes, res.data?.result.totalCount))
			const totalCountPatients =
				getState().appReducer?.searchPatients!.totalPatientsCount
			if (totalCountPatients === undefined) {
				dispatch({
					type: SEARCH_PATIENTS_ACTION_TYPES.SET_TOTAL_COUNT_PATIENTS,
					payload: res.data?.result.totalCount,
				})
			}
			return res.data.result
		} catch (e: any) {
			const error = executeResponseError(e, 'Get patients list error')
			throw new Error(error || '')
		}
	}
}

export const setAppliersFilters = (
	appliersFilters: AppliersFilters
): AppThunkAction => {
	return dispatch => {
		dispatch({
			type: SEARCH_PATIENTS_ACTION_TYPES.APPLY_FILTERS,
			payload: appliersFilters,
		})
	}
}

export const removeFilterFromAppliersFilters = (
	filter: PatientFilter
): AppThunkAction => {
	return dispatch => {
		dispatch({
			type: SEARCH_PATIENTS_ACTION_TYPES.REMOVE_FILTER_FROM_APPLY_FILTERS,
			payload: filter,
		})
	}
}

export const changePatientDataFilterRequest = (
	key: string,
	value: string
): AppThunkAction => {
	return dispatch => {
		dispatch({
			type: SEARCH_PATIENTS_ACTION_TYPES.CHANGE_PATIENT_DATA_REQUEST_FILTER,
			key,
			value,
		})
	}
}

export const setSelectedPatients = (
	patients: Array<PatientDataTableModel>
): AppThunkAction => {
	return dispatch => {
		dispatch({
			type: SEARCH_PATIENTS_ACTION_TYPES.SET_SELECTED_PATIENTS,
			payload: patients,
		})
	}
}
export const setHoldSelectedPatients = (data: boolean): AppThunkAction => {
	return dispatch => {
		dispatch({
			type: SEARCH_PATIENTS_ACTION_TYPES.IS_HOLD_SELECTED_PATIENTS,
			payload: data,
		})
	}
}

export const assignPatient = (
	data: AssignPatientDataRequest
): AppThunkAction<Promise<any>> => {
	return async dispatch => {
		try {
			const res = await api.patient.assignPatient(data)
			if (res) {
				dispatch(setSelectedCoach([]))
				dispatch(setSelectedAssignPatients([]))
			}
		} catch (e: any) {
			const error = executeResponseError(e, 'Assign patient error')
			throw new Error(error || '')
		}
	}
}

export const unassignPatient = (
	data: UnassignPatientDataRequest,
	paramets: any
): AppThunkAction<Promise<any>> => {
	return async dispatch => {
		try {
			const res = await api.patient.unassignPatient(data)
			if (res) {
				dispatch(setSelectedPatients([]))
				dispatch(getPatientsList(paramets))
			}
		} catch (e: any) {
			const error = executeResponseError(e, 'Unassign patient error')
			throw new Error(error || '')
		}
	}
}

export const searchPatientsReset = (): SearchPatientsReset => ({
	type: SEARCH_PATIENTS_ACTION_TYPES.RESET,
})
